<template>
  <div class="content-wrapper">
    <div class="d-flex align-items-center justify-content-between">
      <app-breadcrumb :page-title="$t('shipments')"/>
      <div class="mb-4">
        <button type="button" v-if="$can('create_expenses')"
                class="btn btn-primary btn-with-shadow"
                @click="exportAllShipments">
          <app-icon name="download" class="size-20 mr-2"/>
          {{ $t('export_all') }}
        </button>
        <button type="button" v-if="$can('create_invoices')"
                class="btn btn-success btn-with-shadow"
                @click="openModal">
          <app-icon name="plus" class="size-20 mr-2"/>
          {{ $t('add_shipment') }}
        </button>
      </div>
    </div>

    <app-table
        v-if="$can('view_invoices')"
        :id="tableId"
        :options="options"
        @action="getListAction"/>


    <app-shipments-create-edit-modal
        v-if="isModalActive"
        :table-id="tableId"
        :selected-url="selectUrl"
        :statues="statues"
        :port-types="portTypes"
        :document-status="documentStatus"
        :client-number="clientNumber"
        @openPurposeAddEditModal="openPurposeAddEditModal"
        @closeModal="closeModal"
    />

    <app-delete-modal
        v-if="confirmationModalActive"
        modal-id="delete-confirm-modal"
        :message="$t('are_you_sure_to_delete_this_shipment')"
        @confirmed="confirmDelete"
        @cancelled="cancelledDelete"
    />
  </div>
</template>

<script>
import ShipmentTableMixin from "../../../Mixins/ShipmentTableMixin";
import AppFunction from "../../../../core/helpers/app/AppFunction";
import {axiosGet, urlGenerator} from "../../../Helpers/AxiosHelper";

export default {
  name: "Shipments",
  mixins: [ShipmentTableMixin],
  props: {
    statues: {},
    portTypes: {},
    documentStatus: {},
    clientNumber: '',
  },
  methods: {
    exportAllShipments(){
      window.location.replace(urlGenerator('shipments/export'))
    },
    openPurposeAddEditModal() {
      this.isPurposeModalActive = true;
      setTimeout(() => {
        $('#expense-create-edit-modal').css({
          opacity: '0.5',
        });
      });
    },
    closePurposeAddEditModal() {
      this.isPurposeModalActive = false;
      setTimeout(() => {
        $('#expense-create-edit-modal').css({
          opacity: '1',
        });
      });
      $("#purpose-add-edit-modal").modal("hide");
    },
    afterPurposeAdded() {
      this.$hub.$emit('new-purpose-added')
    },
    closeModal() {
      this.selectUrl = "";
      this.isModalActive = false;
    },
    cancelledDelete() {
      this.selectUrl = '';
      this.confirmationModalActive = false;
      $("#delete-confirm-modal").modal("hide");
    },
  },
  created() {
  }
}
</script>

<style scoped>

</style>
